module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v("\n        Certifikater\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('certificate', {
    attrs: {
      "title": "Transport af foder",
      "issuer": "Fødevarestyrelsen",
      "link": "/static/images/pp_fodertransport_certifikat.pdf"
    }
  }), _vm._v(" "), _c('certificate', {
    attrs: {
      "title": "Transport af farligt gods (ADR)",
      "issuer": "Energistyrelsen",
      "link": "/static/images/pp_farligtgods_certifikat.png"
    }
  }), _vm._v(" "), _c('certificate', {
    attrs: {
      "title": "Bevis for Indsamleruddannelse",
      "issuer": "Miljøministeriet",
      "link": "/static/images/indsamleruddannelse.pdf"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b807b38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/certificates.vue
// module id = 256
// module chunks = 1